(() => {
  'use strict';

  const init = () => {
    const widgets = document.querySelectorAll('[data-tanatel-whatsapp]:not([data-initialized="true"])');

    widgets.forEach((widget) => {
      widget.dataset.initialized = 'true';

      const delay = Math.max(0, Number.parseInt(widget.dataset.delay || '10000', 10));
      const messageDuration = Math.max(1000, Number.parseInt(widget.dataset.messageDuration || '10000', 10));
      const closeButton = widget.querySelector('[data-tanatel-whatsapp-close]');
      const link = widget.querySelector('.tanatel-whatsapp-float__link');
      const hasMessage = Boolean(widget.querySelector('.tanatel-whatsapp-float__message'));
      const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      let revealTimer;
      let messageTimer;
      let touchArmed = false;

      const hideMessage = () => {
        window.clearTimeout(messageTimer);
        widget.classList.remove('is-message-visible');
        touchArmed = false;
      };

      const showMessage = (autoHide = false) => {
        if (!hasMessage) return;
        window.clearTimeout(messageTimer);
        widget.classList.add('is-message-visible');
        if (autoHide) messageTimer = window.setTimeout(hideMessage, messageDuration);
      };

      const reveal = () => {
        if (!document.body.contains(widget)) return;
        widget.classList.add('is-visible');
        widget.setAttribute('aria-hidden', 'false');
        showMessage(true);
      };

      const startTimer = () => {
        window.clearTimeout(revealTimer);
        revealTimer = window.setTimeout(reveal, delay);
      };

      if (document.readyState === 'complete') startTimer();
      else window.addEventListener('load', startTimer, { once: true });

      if (hoverCapable) {
        widget.addEventListener('mouseenter', () => showMessage(false));
        widget.addEventListener('mouseleave', hideMessage);
        widget.addEventListener('focusin', () => showMessage(false));
        widget.addEventListener('focusout', (event) => {
          if (!widget.contains(event.relatedTarget)) hideMessage();
        });
      } else {
        link?.addEventListener('click', (event) => {
          if (hasMessage && !touchArmed && !widget.classList.contains('is-message-visible')) {
            event.preventDefault();
            touchArmed = true;
            showMessage(true);
          }
        });
      }

      closeButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        hideMessage();
      });

      window.addEventListener('pagehide', () => {
        window.clearTimeout(revealTimer);
        window.clearTimeout(messageTimer);
      }, { once: true });
    });
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
